var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebug01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "debug") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.78,
    cy: 12,
    r: 9.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    y1: 0.52,
    x2: 12,
    y2: 2.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12,
    y1: 21.82,
    x2: 12,
    y2: 23.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.52,
    y1: 12,
    x2: 2.06,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.82,
    y1: 12,
    x2: 23.48,
    y2: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.99,
    y1: 10.97,
    x2: 11.99,
    y2: 17.99
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.86,10.32a1.87,1.87,0,0,1-1.2.58,3.77,3.77,0,0,1-1.16,0,2.1,2.1,0,0,1-1.43-.59,1.31,1.31,0,0,1-.22-.78,2.11,2.11,0,0,1,1.77-2.11,3.48,3.48,0,0,1,.36,0,2,2,0,0,1,1.87,1.13A1.49,1.49,0,0,1,13.86,10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.73,13.87A3.94,3.94,0,0,1,12,18a3.94,3.94,0,0,1-3.74-4.12,4.18,4.18,0,0,1,1.82-3.52,2.1,2.1,0,0,0,1.43.59,3.77,3.77,0,0,0,1.16,0,1.87,1.87,0,0,0,1.2-.58A4.16,4.16,0,0,1,15.73,13.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.17 11.25 16.67 11.25 17.42 12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.92 13.5 17.42 13.5 18.16 14.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "15.54 15.74 17.04 15.74 17.79 16.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "8.81 11.25 7.31 11.25 6.56 12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "8.06 13.5 6.56 13.5 5.82 14.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "8.44 15.74 6.94 15.74 6.19 16.49"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.74,7.51A2.32,2.32,0,0,1,13.49,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.24,7.51A2.32,2.32,0,0,0,10.49,6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebug01);
export default __webpack_public_path__ + "static/media/debug_01.127a177ab9949613d7c0817171681a05.svg";
export { ForwardRef as ReactComponent };